import * as React from "react";

export const IconDashboard = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H9V18H7V20H15V18H13V16H20C21.1 16 22 15.1 22 14V2C22 0.9 21.1 0 20 0ZM20 14H2V2H20V14Z"
      fill="white"
    />
  </svg>
);
